import React, { useState, useEffect } from "react";
import moment from "moment";
import {
  Grid,
  Button,
  List,
  Box,
  TextField,
  SwipeableDrawer,
  FormControl,
  InputLabel,
  Typography,
  TablePagination,
  Switch,
  Backdrop,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogActions,
  Select,
  MenuItem,
  CardContent,
  Card,
  CardActions,
  Tooltip,
  Link,
  Chip,
} from "@material-ui/core";
import "react-calendar/dist/Calendar.css";
import "../../../css/employee-page.css";
import useStyles from "../../../themes/style.js";
import PageTitle from "../../../components/PageTitle/PageTitle.js";

import { Calendar, dateFnsLocalizer } from "react-big-calendar";
import format from "date-fns/format";
import parse from "date-fns/parse";
import startOfWeek from "date-fns/startOfWeek";
import getDay from "date-fns/getDay";
import "react-big-calendar/lib/css/react-big-calendar.css";
import axios from "axios";
import { useNotification } from "../../../hooks/useNotification.js";

const CalendarUI = () => {
  const classes = useStyles();
  const token = localStorage.getItem("token");
  const handleNotificationCall = useNotification();

  // Define leave days
  const leaveDays = [
    new Date(2024, 11, 25), // December 25, 2024
    new Date(2024, 11, 31), // December 31, 2024
    new Date(2025, 0, 1), // January 1, 2025
  ];

  const [leaveDates, setLeaveDates] = useState([]);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    fetchAllLeaveDetails();
  }, []);

  const fetchAllLeaveDetails = async () => {
    setLoader(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER}leave/viewAllLeaveForMonth`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );

      setLoader(false);
      if (response.data.status) {
        const responseData = response.data?.data;
        const modifiedResponseData = responseData.map((item) => ({
          title: item.title,
          start: new Date(moment(item.date).format("YYYY-MM-DD")),
          end: new Date(moment(item.date).format("YYYY-MM-DD")),
        }));
        setLeaveDates(modifiedResponseData);
      } else {
        handleNotificationCall("error", response.data.message);
      }
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };

  const locales = {
    "en-US": require("date-fns/locale/en-US"),
  };
  const localizer = dateFnsLocalizer({
    format,
    parse,
    startOfWeek,
    getDay,
    locales,
  });

  const events = [
    {
      title: "Flood Leave",
      start: new Date("2024-12-12"),
      end: new Date("2024-12-12"),
    },
    {
      title: "Government Leave",
      start: new Date("2024-12-18"),
      end: new Date("2024-12-18"),
    },
  ];

  return (
    <div style={{ marginTop: "20px" }}>
      <Grid container direction="row" spacing={2} className={classes.heading}>
        <Grid item xs={9} sm={7} md={8} lg={6}>
          <PageTitle title="Office Calendar" />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Calendar
          views={["day", "week", "month"]}
          localizer={localizer}
          events={leaveDates}
          startAccessor="start"
          endAccessor="end"
          style={{ height: "80vh", backgroundColor: "white", width: "100%" }}
          eventPropGetter={(event) => {
            const style = {
              backgroundColor: "#EDF3FF",
              borderLeft: "5px solid #2C6BED",
              color: "black",
              padding: "5px",
            };
            return { style };
          }}
        />
      </Grid>
    </div>
  );
};

export default CalendarUI;
